module.exports = __webpack_public_path__ + "img/protection-that-matters.eac6c1d3.png";